import styled, { css } from 'styled-components';
import { Button, Input as CustomInput } from '@getinapp/appetizer';

type SelectWrapperProps = {
  required?: boolean;
};

export const Container = styled.div`
  margin-top: 1rem;
`;

export const WrapperForm = styled.div`
  margin-top: 2rem;

  form {
    > div {
      margin-bottom: 1.5rem;
    }
  }
`;

export const WrapperInputWithInfo = styled.div`
  margin-bottom: 2.4rem;

  > .ant-row {
    margin-bottom: 0.5rem;
  }

  > span {
    font-size: 1.1rem;
    ${({ theme }) => css`
      color: ${theme.colors.highContrast};
    `}
  }
`;

export const SmallParagraph = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.xsmall};
    color: ${theme.colors.secondaryDark};

    > a {
      text-decoration: none;

      font-weight: ${theme.font.bold};
      color: ${theme.colors.primary};

      &:hover {
        text-decoration: underline;
      }
    }
  `}
`;

export const TitleSpan = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;
  `};
`;

export const CustomButton = styled(Button)`
  width: 100%;

  margin-top: 1rem;
`;

export const Input = styled(CustomInput)`
  ${({ theme }) => css`
    border-color: ${theme.colors.contrast};
  `}
`;

export const CheckBoxWrapper = styled.div`
  display: flex;
  align-items: center;

  input[type="checkbox"] {
    min-width: 1.5rem;
    min-height: 1.5rem;
    cursor: pointer;

    -webkit-appearance: none;
    appearance: none;

    background-color: #fff;

    margin: 0;

    font: inherit;
    ${({ theme }) => css`
      color: ${theme.colors.contrast};
      border: 1px solid ${theme.colors.contrast};
    `}
    border-radius: 0.15em;
    transform: translateY(-0.075em);

    display: grid;
    place-content: center;
  }

  input[type="checkbox"]::before {
    content: "";

    width: 0.65em;
    height: 0.65em;

    transform: scale(0);
    transition: 120ms transform ease-in-out;
    ${({ theme }) => css`
      box-shadow: inset 1em 1em ${theme.colors.primary};
    `}
  }

  input[type="checkbox"]:checked::before {
    transform: scale(1);
  }

  > svg {
    margin-left: 1rem;
  }

  label {
    margin-left: 1rem;
    ${({ theme }) => css`
      font-size: ${theme.font.sizes.small};
    `}
  }

  .label-small {
    ${({ theme }) => css`
      font-size: ${theme.font.sizes.xsmall};
    `}
  }
`;

export const SelectWrapper = styled.div<SelectWrapperProps>`
  margin-top: 0.55rem;

  ${({ theme }) => css`
    background: ${theme.colors.white};
  `}

  label {
    position: absolute;
    padding: 0 0.35rem;
    ${({ theme, required }) => css`
      color: ${theme.colors.black};
      background: ${theme.colors.white};

      ${required &&
        css`
          &:before {
            content: '* ';
            color: ${theme.colors.primary};
          }
      `}
    `}
    transition: all 0.2s ease-in-out;
    transform-origin: left top;
    cursor: text;
    pointer-events: none;
    transform: translate3d(0, -45.5%, 0) scale(0.9);
    margin-left: 15px;
    font-size: 1.3rem;
  }

  select {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    padding: 0.7rem 1rem;
    padding-top: 1rem;
    padding-left: 1rem;
    padding-right: 3rem;
    outline: none;

    background: transparent;
    background-position-x: 244px;

    ${({ theme }) => css`
      font-family: ${theme.font.family};
      font-style: normal;
      font-weight: normal;
      font-size: 1.5rem;
      border: none;
      width: 100%;
      border-radius: ${theme.border.radius.large};

      &::placeholder {
        color: ${theme.colors.contrast};
        transition: opacity 0.2s cubic-bezier(0.6, 0.04, 0.98, 0.335);
      }

      display: flex;
      align-items: center;
      border: 1px solid ${theme.colors.black};
      border-radius: ${theme.border.radius.large};

      option {
        background: transparent;
      }
    `}
  }
`;
